import { VendorController } from '../../controllers';
import Vendor from '../../pages/Vendor/Vendor';
import { vendorStore, useStores } from '../../stores';
import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';

const VendorContainer = () => {
	const [addVendorModal, setAddVendorModal] = useState(false);
	const [editVendorModal, setEditVendorModal] = useState(false);
	const [viewVendorModal, setViewVendorModal] = useState(false);
	const [deleteVendorModal, setDeleteVendorModal] = useState(false);
	const [vendorMenu, setVendorMenu] = useState(false);

	const {
		userStore,
		vendorStore: { setLoading, loading, vendors, setSelectedVendor },
	} = useStores();

	const logout = () => {
		userStore.setLoggedIn(false);
	};

	useEffect(() => {
		const setVendors = async () => {
			setLoading(true);
			await Promise.all([
				VendorController.getVendors(),
			]);
			setLoading(false);
		};
		setVendors();
	}, [vendorStore]);

	const refresh = async()=> {
		setLoading(true);
		await Promise.all([
			VendorController.getVendors(),
		]);
		setLoading(false);
	}

	const goToAddVendor = () => {
		setAddVendorModal(true);
		setEditVendorModal(false);
		setViewVendorModal(false);
		setDeleteVendorModal(false);
	};

	const goToEditVendor = () => {
		setEditVendorModal(true);
		setViewVendorModal(false);
		setAddVendorModal(false);
		setDeleteVendorModal(false);
	};

	const goToDeleteVendor = () => {
		setDeleteVendorModal(true);
		setEditVendorModal(false);
		setViewVendorModal(false);
		setAddVendorModal(false);
	};

	const handleOptionSelect = (_id, vendorDetail, option) => {
		vendorStore.setSelectedVendor(vendorDetail);
		if (option.value === 'delete vendor') {
			goToDeleteVendor();
		} else if (option.value === 'edit vendor') {
			goToEditVendor();
		} else if (option.value === 'view more') {
			goToViewVendor();
		}
	};

	const goToViewVendor = () => {
		setViewVendorModal(true);
		setEditVendorModal(false);
	};

	const closeModal = () => {
		setAddVendorModal(false);
		setEditVendorModal(false);
		setViewVendorModal(false);
		setDeleteVendorModal(false);
	};

	const showVendorMenu = () => {
		setVendorMenu(!vendorMenu);
	};

	const goBack = () => {
		if (editVendorModal) {
			setEditVendorModal(false);
			setViewVendorModal(true);
		} else {
			closeModal();
		}
	};

	return (
		<div>
			<Vendor
				logout={logout}
				loading={loading}
				vendors={vendors}
				refresh={refresh}
				addVendorModal={addVendorModal}
				goToAddVendor={goToAddVendor}
				closeModal={closeModal}
				setSelectedVendor={setSelectedVendor}
				vendorMenu={vendorMenu}
				showVendorMenu={showVendorMenu}
				editVendorModal={editVendorModal}
				goToEditVendor={goToEditVendor}
				viewVendorModal={viewVendorModal}
				goToViewVendor={goToViewVendor}
				deleteVendorModal={deleteVendorModal}
				goToDeleteVendor={goToDeleteVendor}
				goBack={goBack}
				handleOptionSelect={handleOptionSelect}
			/>
		</div>
	);
};

export default observer(VendorContainer);
